// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d5b887 {
  color: var(--base-text);
}
.b59327 {
  color: var(--base-text-disabled);
}
.e6af6f {
  display: flex;
  position: relative;
  margin-bottom: 4px;
  margin-top: 8px;
}
.a744ca {
  line-height: 1.25;
  font-size: 1rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
  align-items: flex-start;
  background-color: var(--base-primary-reverse);
  border: 1px solid var(--base-tertiary-interactive);
  display: flex;
  height: 128px;
  resize: none;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-inline-start: 16px;
  padding-inline-end: 48px;
}
.af73e8 {
  padding-inline-end: 32px;
}
.a744ca:hover {
  border-color: var(--base-tertiary-interactive-hover);
}
.a744ca:focus {
  outline: none;
  border-color: var(--base-tertiary-interactive-active);
}
.c519bf {
  border-color: var(--base-tertiary-interactive-disabled);
  background-color: var(--base-interactive-disabled);
  cursor: not-allowed;
}
.c519bf:hover {
  border-color: var(--base-tertiary-interactive-disabled);
}
.c519bf:focus {
  outline: none;
  border-color: var(--base-tertiary-interactive-disabled);
}
.f87276 {
  border-color: var(--base-validation-error);
}
.f87276:hover {
  border-color: var(--base-validation-error);
}
.f87276:focus {
  outline: none;
  border-color: var(--base-validation-error);
}
.bb9194 {
  border-color: var(--base-validation-success);
}
.bb9194:hover {
  border-color: var(--base-validation-success);
}
.bb9194:focus {
  outline: none;
  border-color: var(--base-validation-success);
}
.e4cf3c {
  position: absolute;
  max-height: 16px;
  inset-inline-end: 0;
  margin-top: 16px;
  margin-inline-end: 16px;
}
.ef4c0c {
  margin-inline-end: 24px;
}
.f7b111 {
  fill: var(--base-validation-success);
}
.a55227 {
  fill: var(--base-validation-error);
}
.e81e68 {
  color: var(--base-text-meta);
  display: flex;
}
.f16359 {
  color: var(--base-validation-error);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Fields/TextArea/TextArea.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,6CAA6C;EAC7C,kDAAkD;EAClD,aAAa;EACb,aAAa;EACb,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EAEZ,0BAA0B;EAE1B,wBAAwB;AAClC;AACA;EAEU,wBAAwB;AAClC;AACA;EACE,oDAAoD;AACtD;AACA;EACE,aAAa;EACb,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,uDAAuD;AACzD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAER,uBAAuB;AACjC;AACA;EAEU,uBAAuB;AACjC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,mCAAmC;AACrC","sourcesContent":[".d5b887 {\n  color: var(--base-text);\n}\n.b59327 {\n  color: var(--base-text-disabled);\n}\n.e6af6f {\n  display: flex;\n  position: relative;\n  margin-bottom: 4px;\n  margin-top: 8px;\n}\n.a744ca {\n  line-height: 1.25;\n  font-size: 1rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n  align-items: flex-start;\n  background-color: var(--base-primary-reverse);\n  border: 1px solid var(--base-tertiary-interactive);\n  display: flex;\n  height: 128px;\n  resize: none;\n  width: 100%;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  -webkit-padding-start: 16px;\n          padding-inline-start: 16px;\n  -webkit-padding-end: 48px;\n          padding-inline-end: 48px;\n}\n.af73e8 {\n  -webkit-padding-end: 32px;\n          padding-inline-end: 32px;\n}\n.a744ca:hover {\n  border-color: var(--base-tertiary-interactive-hover);\n}\n.a744ca:focus {\n  outline: none;\n  border-color: var(--base-tertiary-interactive-active);\n}\n.c519bf {\n  border-color: var(--base-tertiary-interactive-disabled);\n  background-color: var(--base-interactive-disabled);\n  cursor: not-allowed;\n}\n.c519bf:hover {\n  border-color: var(--base-tertiary-interactive-disabled);\n}\n.c519bf:focus {\n  outline: none;\n  border-color: var(--base-tertiary-interactive-disabled);\n}\n.f87276 {\n  border-color: var(--base-validation-error);\n}\n.f87276:hover {\n  border-color: var(--base-validation-error);\n}\n.f87276:focus {\n  outline: none;\n  border-color: var(--base-validation-error);\n}\n.bb9194 {\n  border-color: var(--base-validation-success);\n}\n.bb9194:hover {\n  border-color: var(--base-validation-success);\n}\n.bb9194:focus {\n  outline: none;\n  border-color: var(--base-validation-success);\n}\n.e4cf3c {\n  position: absolute;\n  max-height: 16px;\n  inset-inline-end: 0;\n  margin-top: 16px;\n  -webkit-margin-end: 16px;\n          margin-inline-end: 16px;\n}\n.ef4c0c {\n  -webkit-margin-end: 24px;\n          margin-inline-end: 24px;\n}\n.f7b111 {\n  fill: var(--base-validation-success);\n}\n.a55227 {\n  fill: var(--base-validation-error);\n}\n.e81e68 {\n  color: var(--base-text-meta);\n  display: flex;\n}\n.f16359 {\n  color: var(--base-validation-error);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
